/**
 * CMS content-related API endpoints
 */
import { apiGet, apiPost } from "./client.js";

/**
 * Fetches home page content
 * @returns {Promise<Response>} Home page response
 */
export const getHome = () => apiGet("/home", { populate: "*" });

/**
 * Fetches menu configuration
 * @returns {Promise<Response>} Menu response
 */
export const getMenu = () => apiGet("/menu", { populate: "*" });

/**
 * Fetches about page content
 * @returns {Promise<Response>} About page response
 */
export const getAbout = () => apiGet("/about-us", { populate: "*" });

/**
 * Fetches contact page content
 * @returns {Promise<Response>} Contact page response
 */
export const getContact = () => apiGet("/contact", { populate: "*" });

/**
 * Submits contact form data
 * @param {Object} formData - Contact form data
 * @returns {Promise<Response>} Contact form submission response
 */
export const submitContact = (formData) => apiPost("/contact", formData);

/**
 * Fetches FAQ page content
 * @returns {Promise<Response>} FAQ page response
 */
export const getFaq = () => apiGet("/faq", { populate: "*" });

/**
 * Fetches global SEO settings
 * @returns {Promise<Response>} Global SEO response
 */
export const getSeoGlobal = () => apiGet("/seo-global", { populate: "*" });

/**
 * Fetches site settings including logo
 * @returns {Promise<Response>} Site settings response
 */
export const getSiteSettings = () => apiGet("/seo-global", { "populate[logo]": "*" });

/**
 * Fetches privacy policy content
 * @returns {Promise<Response>} Privacy policy response
 */
export const getPrivacyPolicy = () => apiGet("/privacy-policy", { populate: "*" });

/**
 * Fetches terms and conditions content
 * @returns {Promise<Response>} Terms and conditions response
 */
export const getTermsAndConditions = () => apiGet("/terms-and-conditions", { populate: "*" });

/**
 * Claim a discount code via popup (sends email with unique code)
 * @param {Object} payload - { email, recaptchaToken }
 * @returns {Promise<Response>} Claim response
 */
export const claimDiscountPopup = (payload) => apiPost("/discount-popup/claim", payload);

/**
 * Validate a discount code
 * @param {string} code - Discount code to validate
 * @returns {Promise<Response>} Validation response
 */
export const validateDiscountCode = (code) => apiPost("/discount-popup/validate-code", { code });

/**
 * Fetches footer content and configuration
 * @returns {Promise<Response>} Footer response
 */
export const getFooter = () =>
  apiGet("/footer", {
    populate: {
      logo: "*",
      social_networks: { populate: "*" },
      link_groups: { populate: "*" },
    },
  });
